import type { IEntityModel } from './base'
import type { IIdentityProjectSettings } from './identity_project_settings'
import type { IInvite } from './invite'
import type { IPhone } from './phone'
import type { IProfile } from './profile'
import type { ISettings } from './settings'
import type { IWorkspace } from './workspace'
import type { IWorkspaceFavorite } from './workspace_favorite'

export enum IdentityType {
  Admin = 'admin',
  User = 'user',
}

export interface IIdentity extends IEntityModel {
  type: IdentityType
  email: string
  emailVerified: boolean
  secretPasswordHash: string
  secretOtpSeed?: string
  secretRecoveryCodeList?: string | null
  phoneId?: string | null
  phone?: IPhone
  profileId?: string | null
  profile?: IProfile
  workspaceId?: string | null
  workspace?: IWorkspace
  settingsId?: string | null
  settings?: ISettings
  mfaEnabled: boolean
  deactivated: boolean
  /** Server-only: dropped from every JSON serialization by the model. */
  sessionLegacyCutoffAt?: Date | null
  workspaceFavoriteList?: IWorkspaceFavorite[]
  projectSettingsList?: IIdentityProjectSettings[]
  inviteList?: IInvite[]
}
